import { useState, useEffect } from "react";
import axios from "axios";

const API = process.env.REACT_APP_BACKEND_URL + "/api";

export const useNotificationCount = () => {
  const [notificationCount, setNotificationCount] = useState(0);

  useEffect(() => {
    const fetchCount = async () => {
      try {
        const res = await axios.get(`${API}/admin/notification-count`, { withCredentials: true });
        setNotificationCount(res.data.total || 0);
      } catch {
        // Ignore - user might not be admin
      }
    };
    
    fetchCount();
    const interval = setInterval(fetchCount, 30000); // Poll every 30s
    return () => clearInterval(interval);
  }, []);

  return notificationCount;
};
